import { useState, useEffect } from 'react';
import { useLocation } from '@thd-olt-component-react/router';

export const useVariationIds = ({ mboxes = [], isReady = true }) => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const [variationIds, setVariationIds] = useState(null);
  const [renderDefault, setRenderDefault] = useState(false);

  const formatLocationIds = (locations) => {
    const ids = locations
      ? locations
        .map((loc) => loc[0])
        .reduce((acc, arr) => acc.concat(...arr.variationsIds), [])
      : [];

    return ids;
  };

  useEffect(() => {
    const getVariationIds = async () => {
      if (!variationIds && isReady) {
        const idsFromQuery = query.get('variationIds');

        if (idsFromQuery) {
          const ids = idsFromQuery.split(',');

          setVariationIds(ids);
          if (ids.length < 1) setRenderDefault(true);
        } else {
          try {
            /* eslint-disable-next-line no-undef */
            const adobeTriggerLocations = await adobe.target.ext.triggerLocations(mboxes);
            const ids = formatLocationIds(adobeTriggerLocations);

            setVariationIds(ids);
            if (ids.length < 1) setRenderDefault(true);
          } catch (err) {
            /* eslint-disable-next-line no-console, no-unused-expressions */
            window.isDebugMode && console.error(err);
            // Needed to show the default if Adobe is down
            setRenderDefault(true);
          }
        }
      }
    };

    getVariationIds();
  }, [isReady]);

  return {
    variationIds,
    renderDefault,
  };
};
